import { SectionHeading } from "~/components/DetailsPage/components";
import { EmptySection } from "~/components/vulnerabilities";
import { useAssetSoftwareVulnerabilities } from "~/pages/inventory/components/AssetSoftwareDetails/AssetSoftwareVulnerabilities/hooks/useAssetSoftwareVulnerabilities";
import { FindingsTable } from "~/pages/inventory/components/Findings/FindingsTable/FindingsTable";
import { Box } from "@mui/material";
import { LoadingFailedPage } from "~/components/loading";

type SoftwareVulnerabilitiesProps = {
  assetMrn: string;
  softwareMrn: string;
};

export const AssetSoftwareVulnerabilities = ({
  assetMrn,
  softwareMrn,
}: SoftwareVulnerabilitiesProps) => {
  const { cves, totalCount, paginationProps, hasCVEs, hasError, assetId } =
    useAssetSoftwareVulnerabilities({
      assetMrn,
      softwareMrn,
    });

  if (hasError) {
    return <LoadingFailedPage what="Vulnerabilities" />;
  }

  return (
    <Box data-testid="software-vulnerabilities">
      <SectionHeading heading="Vulnerabilities" />
      {hasCVEs ? (
        <FindingsTable
          findings={cves}
          totalCount={totalCount}
          entityMrn={assetMrn}
          context="cve"
          assetId={assetId}
          paginationProps={paginationProps}
        />
      ) : (
        <EmptySection
          id="software-cves-empty"
          text="There are currently no known vulnerabilities for this software"
        />
      )}
    </Box>
  );
};
